/**
 * Image paths that will be used throught the app.
 */
export default {
  CONNECTOR_LOGO: connectorName =>
    require(`@/assets/images/connector/${connectorName}.svg`),
  XIFT_LOGO: require('@/assets/images/xift-logo.svg'),
  PAYMENT_CARD_LOGO: cardType =>
    require(`@/assets/images/PaymentCardLogos/${cardType}.svg`)
};
